import { Link } from "react-router-dom";
import { AlarmClock } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatInt, formatMoney, sumCents, lazyPage } from "@vixio/ui";
import "./api";
import { useCollectionsKpis, useProvisions } from "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const CollectionsPage = lazyPage(() => import("./CollectionsPage"), "CollectionsPage");
const CasePage = lazyPage(() => import("./CasePage"), "CasePage");

function CollectionsWidget() {
  const org = useOrg();
  const k = useCollectionsKpis(org.id).data;
  const pdd = sumCents((useProvisions(org.id).data ?? []).map((p) => p.provision_cents));
  return (
    <dl className="vx-dl">
      <dt>Casos ativos</dt>
      <dd className={(k?.activeCount ?? 0) > 0 ? "num text-crit" : "num"}>{formatInt(k?.activeCount ?? 0)}</dd>
      <dt>Saldo em cobrança</dt>
      <dd className="num">{formatMoney(k?.activeCents ?? 0)}</dd>
      <dt>PDD estimada</dt>
      <dd className="num">{formatMoney(pdd)}</dd>
      <dt />
      <dd>
        <Link to="/dinheiro/inadimplencia">Abrir inadimplência</Link>
      </dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "collections",
  title: "Inadimplência",
  domain: "money",
  icon: AlarmClock,
  menu: [
    { path: "/dinheiro/inadimplencia", label: "Inadimplência", minRole: "manager", icon: AlarmClock, order: 47, keywords: "cobrança régua acordo renegociação pdd provisão atraso" },
  ],
  routes: [
    { path: "/dinheiro/inadimplencia", element: <CollectionsPage />, minRole: "manager" },
    { path: "/dinheiro/inadimplencia/casos/:id", element: <CasePage />, minRole: "manager" },
  ],
  widgets: [{ key: "collections.cases", title: "Inadimplência", minRole: "manager", span: 1, order: 25, element: CollectionsWidget }],
});
